import useInterval from 'core/hooks/useInterval'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { refreshImage } from './actions'

const POLL_INTERVAL = 5000

// Keeps the Stores column live while images are copying to their stores.
//
// While any image is importing, re-fetch each importing image every few seconds and write it back
// to the cache (refreshImage does that). The Stores column reads from the cache, so it updates on
// its own. Once an image finishes importing it drops out of `importingIds`, and when none are left
// the interval is disabled (delay = null) and polling stops. Spec FR-5 / S4.
export default function useImportProgress(importingIds: string[]) {
  const { bulkUpdate: refreshImages } = useUpdateAction(refreshImage)

  useInterval(
    () => {
      refreshImages(importingIds.map((id) => ({ id })))
    },
    importingIds.length ? POLL_INTERVAL : null,
  )
}
